import CryptoJS from "crypto-js";
// export const BASE_URL = "http://localhost:3500/api";
export const BASE_URL = "https://bakelandcrm.yorotechnologies.com/api";
// export const BASE_URL = "https://yorocrmapi.yorotechnologies.com/api";
export const secretKey = "mySuperSecretKey123!";
// export const Host_URL = "https://localhost:3001/"
export const Host_URL = "https://bakelandcrm.yorotechnologies.com/";
// Socket server base URL (derived from BASE_URL)
export const SOCKET_URL = BASE_URL.replace(/\/api\/?$/, "");

export const encryptData = (data) => {
  return CryptoJS.AES.encrypt(data, secretKey).toString().replace(/\//g, "");
};

// Function to Decrypt Data
export const decryptData = (encryptedData) => {
  const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
  return bytes.toString(CryptoJS.enc.Utf8);
};
